import React from 'react';
import { useTranslation } from "react-i18next";


export default function Home()
{
    const { t } = useTranslation();
    return(
        <header className="masthead bg-primary text-white text-center">
            <div className="container d-flex align-items-center flex-column">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-white" style={{margin:'20px'}}>Toolsoft Interactive</h2>
                <div className="row">
                    <div className="col-lg-4 ms-auto"><p className="lead">{t('home_text1')}</p></div>
                    <div className="col-lg-4 me-auto"><p className="lead">{t('home_text2')}</p></div>
                </div>
                <div className="row">
                    <div className="col-lg-4 ms-auto"><p className="lead">{t('home_text3')}</p></div>
                    <div className="col-lg-4 me-auto"><p className="lead">{t('home_text4')}</p></div>
                </div>
            </div>
            </div>
        </header>
    )
}